import React from 'react'
import { createGlobalStyle } from 'styled-components';
import { Modal } from 'react-bootstrap';
import BaseBtn from '../../components/common/styled/BaseBtn'
import WhiteBtn from '../../components/common/styled/WhiteBtn'
import ModelBody from "../model/sub/ModelBody"
import BtnGroup from "../model/sub/BtnGroup"
import PropTypes from 'prop-types'

const GlobalStyle = createGlobalStyle`
  .supportSubjectModel {
    font-size: 20px;
    .modal-dialog {
      max-width: 980px;
    }
    .modal-title {
      color: #333;
      font-size: 20px;
      .sub-title {
        font-weight: 400;
        >h4 {
          font-size: 20px;
          color: #007bff;
          cursor: pointer;
        }
        >ul {
          height: 0;
          opacity: 0;
          transition: all .6s;
          padding-left: 20px;
          list-style: disc;
          font-size: 14px;
          color: #999;
        }
        &:hover {
          >ul {
            height: 60px;
            opacity: 1;
          }
          @media (max-width: 768px) {
            >ul {
              height: auto;
            }
          }
        }
      }
    }
    .notice {
      color: #FF4540;
      text-align: center;
      >a {
        margin-left: 40px;
        text-decoration: underline;
      }
    }
  }
`

export default function SupportSubjectModel(props) {
  return (
    <>
      <GlobalStyle />
      <Modal show={props.show}
        className="supportSubjectModel"
        onHide={props.onHide}
      >
        <Modal.Header>
          <Modal.Title> 
            {/* <div>
              <a target="_blank" rel="noreferrer" href="https://docs.google.com/document/d/1LwBybMyd0nhEqy84U61VKPRd2HkvlnNxs8ze-hTRp_0/edit?usp=sharing">
              How to grant TRIAS through personal wallet ?
              </a>
            </div> */}
            <div className="sub-title">
              <h4>How to support the hunters？</h4>
              <ul>
                <li>Supporting the hunter means you should donate TRIAS to them. </li>
                <li>The donation would be sent to the hunter along with rewards when the results come out. </li>
                <li>There's no limitation on the amount of donation. </li>
              </ul>
            </div>
          </Modal.Title>
          {/*<span className="right-title">Connect Wallet<i className="fa fa-arrow-right"></i></span>*/}
        </Modal.Header>
        <Modal.Body>
          <p className="notice">
          Please use browser(PC) with the extension of Metamask, or you can't vote successfully.
          <a target="_blank" rel="noreferrer" href="https://docs.google.com/document/d/1Q5yIAmgkKgwbyx0xZsB0r0mmnah8LS8YTV797GYgI6Q/edit?usp=sharing">guidance</a>
          </p>
          <ModelBody>Are you sure to support this hunter？</ModelBody>
          <BtnGroup>
            <WhiteBtn width="240px" onClick={props.onHide} heigth="42px">Let me think again</WhiteBtn>
            <BaseBtn onClick={()=>{
              props.onHide()
              props.toSupport()
            }} width="240px" heigth="42px">Yes, support now</BaseBtn>
          </BtnGroup>
        </Modal.Body>
      </Modal>
    </>
  )
}

SupportSubjectModel.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
}
